import { BaseApi } from '@/modules/core/base.api';
import { Alert } from './alert';
import * as API from '@shared/common/api';
import { PaginationResult } from '@shared/common/types';

class AlertApi extends BaseApi {
    public apiPath = 'alert';

    public async getCount(): Promise<API.GetAlertCount> {
        const response = await this.api.get<API.GetAlertCount>(this.baseUrlFor('count'));
        return response.data;
    }

    public async findAll(options: any = {}): Promise<Alert[] | PaginationResult<Alert>> {
        const response = await this.api.get(this.baseUrlFor(), {
            params: {
                ...options,
            },
        });

        if (!Array.isArray(response.data)) {
            response.data.items = response.data.items.map((alert: any) => new Alert(alert));
        }

        return response.data;
    }

    public async getMessageVariables(): Promise<API.GetMessageVariables> {
        const response = await this.api.get<API.GetMessageVariables>(this.baseUrlFor('message-variables'));
        return response.data;
    }

    public getExportUrl(options?: any): string {
        return this.api.getUri({ url: this.baseUrlFor('export'), params: options ? { sort: options.sort, ...options.filters } : undefined });
    }
}

export const alertApi = new AlertApi();
